module.exports = __webpack_public_path__ + "87f63df534bdaeea0f6efef4c58bfb1f.pdf";